import { createUSeDirectBookingStrategy } from "./usedirect.js";

const bookingBaseUrl = "https://www.reservenevada.com/NevadaWeb/Default.aspx";
const strategy = createUSeDirectBookingStrategy({ bookingBaseUrl });

export default {
  ...strategy,
  buildPreviewUrl(site, facility) {
    const placeId = facility?.extraAttributes?.placeId;
    return placeId ? `${bookingBaseUrl}#!park/${placeId}` : site.reserveUrl;
  },
};
